import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const isBrowser = typeof window !== 'undefined';
  const token = isBrowser ? localStorage.getItem('auth_token') : null;

  const headers: { [key: string]: string } = {
    'X-API-Key': environment.apiKey
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // Add API key and enable credentials for all API requests
  const clonedRequest = req.clone({
    withCredentials: true, // Enable cookies for authentication
    setHeaders: headers
  });

  return next(clonedRequest);
};
